import { defineProvider } from '@nuxt/image/runtime'

export default defineProvider<{ baseURL?: string; domains?: string[]; defaultFormat?: string; excludeExtensions?: string[] }>({
  getImage(src, options) {
      let url: URL
      try {
        url = new URL(src)
      } catch {
        return { url: src }
      }

      const allowedDomains = options.domains || []
      const isAllowed = allowedDomains.includes(url.hostname)
      const { width, height, format } = options.modifiers

      const ext = url.pathname.split('.').pop()?.toLowerCase()
      const excludedExtensions = options.excludeExtensions || [];
      const resolvedFormat = !(ext && excludedExtensions.includes(ext)) ? (format ?? options.defaultFormat) : null;

      // Previously this bailed out unless width/height/format were explicitly
      // passed to <NuxtImg>, so any call site that only relies on `defaultFormat`
      // (e.g. icons/logos rendered without a width/height prop) silently skipped
      // the CDN transform and shipped the raw, unconverted source image.
      if (!isAllowed || !(width || height || resolvedFormat || url.pathname.includes('/cdn-cgi/image/'))) {
        return { url: src }
      }

      const cfParams: Record<string, string> = {
        ...(width && { width: String(width) }),
        ...(height && { height: String(height) }),
        ...(resolvedFormat && { format: resolvedFormat }),
      }

      const query = Object.entries(cfParams).map(([k, v]) => `${k}=${v}`).join(',')
      return {
        url: query ? `${url.origin}/cdn-cgi/image/${query}${url.pathname}` : src
      }
    },
})

